import React from "react";
import { PRODUCT } from "./products";
import { ShopContext } from "./Context";
import { useContext } from "react";
import CartItem from "./CartItem";
import {Link} from "react-router-dom"
import { Key } from "phosphor-react";
const Cart = () => {
  const {  cartItems,getTotalCartAmount } = useContext(ShopContext);
  const totalAmount=getTotalCartAmount()
  return (
    <div className="cart py-2 ">
      <div className="mx-[25%] text-center text-3xl font-serif">
        Your Cart Items
      </div>

      {PRODUCT.map((product) => {
        if (cartItems[product.id] !== 0) {
          return <CartItem data={product} /> 
          
        }
      })}

       <div className="mx-[25%]">
        <p  className="text-3xl text-center py-4">SubTotal:${totalAmount}</p>
       <Link to="/"> <button className="text-center mr-[20rem] w-[12rem] h-[4rem] py-2 text-xl rounded-lg bg-purple-400">Continue Shopping</button></Link>
       <Link to="/Thankyou"> <button className="text-center w-[12rem] h-[4rem] py-2 text-xl rounded-lg bg-purple-400">Checkout</button></Link>
      </div>
    </div>
  );
};

export default Cart;
